/**
 * @generated SignedSource<<e416d193af1d9b63e8f052bf6e06aaea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApplicationMutationsRemoveApplicationMutation$variables = {
  id: string;
};
export type ApplicationMutationsRemoveApplicationMutation$data = {
  readonly deleteApplication: {
    readonly id: string;
  };
};
export type ApplicationMutationsRemoveApplicationMutation = {
  response: ApplicationMutationsRemoveApplicationMutation$data;
  variables: ApplicationMutationsRemoveApplicationMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id',
          },
        ],
        concreteType: 'Application',
        kind: 'LinkedField',
        name: 'deleteApplication',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'ApplicationMutationsRemoveApplicationMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'ApplicationMutationsRemoveApplicationMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '98541662b0284ab4bd497375bf3e8f8f',
      id: null,
      metadata: {},
      name: 'ApplicationMutationsRemoveApplicationMutation',
      operationKind: 'mutation',
      text: 'mutation ApplicationMutationsRemoveApplicationMutation(\n  $id: ID!\n) {\n  deleteApplication(id: $id) {\n    id\n  }\n}\n',
    },
  };
})();

(node as any).hash = '141b2e286ff788dcdb436c5de9ad21bc';

export default node;
